<template>
    <span class="c-formFlag">
        <slot/>
    </span>
</template>

<style lang="scss">
.c-formFlag {
    color: var(--k-gray-500);
}
</style>
